import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Icon } from '~/components/atomic';
import IconButtonWrapper from '../../IconButtonWrapper/IconButtonWrapper';

interface CharacterLikedProps {
  id: string;
  is_liked: boolean;
  handleLikeClick: (id: string, isLiked: boolean) => void;
}

export default function CharacterLiked({
  id,
  is_liked,
  handleLikeClick,
}: CharacterLikedProps) {
  return (
    <StyledIconWrapper
      onClick={(e) => {
        e.stopPropagation();
        handleLikeClick(id, is_liked);
      }}
      size={44}
    >
      <Icon size={32} iconName={is_liked ? 'Favorite' : 'FavoriteStroke'} />
    </StyledIconWrapper>
  );
}

export const StyledIconWrapper = styled(IconButtonWrapper)`
  ${({ theme }) => css`
    color: ${theme.content.content_light_1};
  `}
`;
